'use client';

import WelcomeFooter from '@/components/layout/WelcomeFooter';
import { WelcomeNavbar } from '@/components/layout/WelcomeNavbar';

export default function PublicLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-full min-h-screen flex flex-col">
      <WelcomeNavbar />
      <main className="pt-20 w-full flex-1">{children}</main>
      <div className="w-4/5 h-px bg-white mx-auto"></div>
      <WelcomeFooter />
    </div>
  );
}
